import { Button } from "antd";
import React from "react";
import { _adr } from "../../../../address";
import OprationResult from "../../../auxiliary/opration/opration";
import { convertToJalaliWithTime, formatTime } from "../../../../tools/tools";

export const FactorCard = ({ t, creditCard, setCreditCard }) => {
	return (
		<>
			<div className="g-body-format-page">
				<OprationResult
					isSucess={true}
					list={[
						{
							label: "تاریخ و ساعت",
							value: (
								<span dir="ltr">
									{convertToJalaliWithTime(new Date().toISOString())} - {formatTime(new Date())}
								</span>
							),
						},
						{
							label: "نوع سرویس",
							value: <>دریافت کارت بانکی ترکیه</>,
						},
						{
							label: "شماره همراه",
							value: <span dir="ltr">{creditCard?.profile?.mobile}</span>,
						},
						{
							label: "کد پیگیری",
							value: <span dir="ltr">{creditCard?.card?.Result?.followUpCode}</span>,
						},
					]}
				/>
			</div>
			<div className="g-footer-format-page">
				<div className="holder-button">
					<Button
						className="btn-normal btn-aptel"
						onClick={() => setCreditCard((prev) => ({ ...prev, profile: null, address: null, step: null }))}
						type="default">
						بازگشت
					</Button>
					<Button className="btn-normal btn-print" onClick={() => window.print()} type="default" icon={<i className="icon-print"></i>}>
						چاپ فاکتور
					</Button>
				</div>
			</div>
		</>
	);
};
